import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";

@Directive({ selector: "[customDateFormatter]" })
export class CustomDateFormatterDirective implements OnInit {

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef
  ) {
    this.el = this.elementRef.nativeElement;
    alert(this.el);
  }

  ngOnInit() {
    alert("hi");

    this.el.value = "11/12/2012";
  }


  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {

    this.el.value = "10/12/2012";
  }

}